import React from 'react';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import '../../product-overview.scss';

export const ProductOverviewAccordionTitleComponent = () => {
  return (
    <>
      <h3 className="product-details-accordion-header">Product Details</h3>
    </>
  );
};

ProductOverviewAccordionTitleComponent.displayName = 'ProductOverviewAccordionTitleComponent';

const DynamicComponent = withDynamicComponent(ProductOverviewAccordionTitleComponent);
const ProductOverviewAccordionTitle = withLayoutGroup({
  name: 'product-overview-accordion-title'
}, DynamicComponent);

ProductOverviewAccordionTitle.displayName = 'ProductOverviewAccordionTitle';

export { ProductOverviewAccordionTitle };